import { Popover } from 'antd';
import cashierActions from 'features/cashier/services/actions';
import cashierSelectors from 'features/cashier/services/selectors';
import { ICustomerServicePackage, IUseCustomerPackageSession } from 'features/cashier/services/types/customer-service-package';
import { useEffect, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import PackageCard from './package-card';
import PackagesDetailModal from './PackagesDetailModal';
import { PackagePopoverList } from './styles';

/**
 * Gói liệu trình của khách đang chọn.
 * Một thẻ duy nhất dù khách có nhiều gói; bấm thẻ sổ popover liệt kê tất cả.
 * Dùng buổi chỉ qua modal chi tiết (thẻ không có nút APPLY).
 * Ẩn hoàn toàn khi ticket chưa có khách hoặc khách không còn gói dùng được.
 */
const CustomerPackages = () => {
  const dispatch = useAppDispatch();
  const packages = cashierSelectors.getUsableCustomerPackages();
  const customerId = cashierSelectors.getSelectedCustomer()?.customerId;
  const displayPackageService = shopSelectors.data.displayPackageService();
  const [visibleDetail, setVisibleDetail] = useState(false);
  const [visiblePopover, setVisiblePopover] = useState(false);

  // component vẫn mounted khi ẩn thẻ, nên đổi khách phải tự đóng modal / popover của khách cũ
  useEffect(() => {
    setVisibleDetail(false);
    setVisiblePopover(false);
  }, [customerId]);

  // shop tắt tính năng gói thì ẩn cả khi store còn dữ liệu gói của lần tải trước
  if (!displayPackageService || !customerId || !packages.length) return null;

  const openDetail = () => {
    setVisiblePopover(false);
    setVisibleDetail(true);
  };

  const handleUseSessions = (sessions: IUseCustomerPackageSession[]) => {
    dispatch(cashierActions.useCustomerPackageSessions(sessions));
  };

  const renderCard = (data: ICustomerServicePackage) => (
    <PackageCard
      key={data.id}
      data={data}
      onOpenDetail={openDetail}
    />
  );

  const [firstPackage] = packages;
  const hasMany = packages.length > 1;

  return (
    <>
      {hasMany ? (
        <Popover
          open={visiblePopover}
          onOpenChange={setVisiblePopover}
          trigger='click'
          placement='bottomLeft'
          // cột ticket có overflow riêng, neo popover vào body để không bị cắt
          getPopupContainer={() => document.body}
          content={<PackagePopoverList>{packages.map(renderCard)}</PackagePopoverList>}
        >
          <div>
            <PackageCard
              data={firstPackage}
              // Popover tự bật/tắt khi bấm thẻ; tự set true ở đây sẽ mở lại ngay sau khi antd vừa đóng
              onOpenDetail={() => undefined}
            />
          </div>
        </Popover>
      ) : (
        renderCard(firstPackage)
      )}

      <PackagesDetailModal
        visible={visibleDetail}
        packages={packages}
        onClose={() => setVisibleDetail(false)}
        onUseSessions={handleUseSessions}
      />
    </>
  );
};

export default CustomerPackages;
